// Write your Layout Query Here

module.exports = function(locale, preview) {
  return `
  fragment ImageButtonFragment on ImageButton {
    __typename
    sys {
      id
    }
    name
    image {
      src: url
      url
    }
    altText
    link
    tooltip
    gaEventClass
    gaEventLabel
  }
  fragment ImageFragment on Image {
    sys {
      id
    }
    name
    altText
    styles
    image {
      url
      fileName
      contentType
    }
    tooltip
    __typename
  }

 

  {
    headerCollection(limit: 1, locale: "${locale}", preview: ${preview}) {
      items {
        headerLinksCollection(limit: 2) {
          items {
            name
            link
          }
        }
        crmSection {
          loginText
          loginUrl
          registerText
          registrerUrl
        }
        brandLogo {
          ...on LinkButton{
            name
            linkText
            link 
            styles
          }
          ...on ImageButton{
            name
            image{
              url
            }
            link
          }
        }
        relatedBrandCollection(limit: 1) {
          items {
            text
            linksCollection {
              items {
                ... on ImageButton {
                  ...ImageButtonFragment
                }
              }
            }
          }
        }
        primaryNavCollection(limit: 6) {
          items {
            menuText
            menuLink
            iconCollection(limit: 1) {
            items {
              __typename
              ... on Image {
                ...ImageFragment
              }
              ... on ImageButton {
                ...ImageButtonFragment
              }
            }
          }
            menuSlotsCollection(limit: 5) {
              items {
                name
                image {
                  url
                }
                link
                text
                title
                styles
                linkButtonCollection{
                  items{
                    sys{
                      id
                    }
                    name
                  linkText
                  link
                  variant
                  tooltip
                  styles
                  }
                }
                menuItemsCollection(limit: 40) {
                  items {
                    menuText
                    menuLink
                    column
                    styles
                  }
                }
              }
            }
          }
        }
        countrySelectorsCollection(limit: 45) {
          items {
          ... on LinkContainer {
            name
            text
            linksCollection {
              items {
                ... on LinkButton {
                  name
                  linkText
                  link
                  tooltip
                  target
                }
              }
            }
          }
        }
      }
     
      }
    }
     
    footerCollection(limit: 1, locale: "${locale}", preview: ${preview}) {
      items {
        name
       
        socialConnect {
          sys {
            id
          }
          name
          linksCollection(limit: 4) {
            items {
              __typename
              ... on ImageButton {
                ...ImageButtonFragment
              }
            }
          }
        }
        footerLinksCollection(limit: 7) {
          items {
            __typename
            ... on LinkButton {
              target
              linkText
              link
              tooltip
              gaEventClass
              gaEventLabel
            }
            __typename
            ... on ImageButton{
              ...ImageButtonFragment
            }
            ... on SectionContainer {
              sys{
                id
              }
              sectionContentCollection(limit: 1) {
                items {
                  __typename
                  ... on Accordian {
                    sys{
                      id
                    }
                    styles
                    variant
                    accordianPanelsCollection(limit: 2) {
                      items {
                        __typename
                        ... on AccordianPanel {
                          sys{
                            id
                          }
                          titleContentCollection(limit: 1) {
                            items {
                              __typename
                              ... on SectionContainer {
                                sys{
                                  id
                                }
                                styles
                                sectionContentCollection(limit: 2) {
                                  items {
                                    __typename
                                    ... on LinkButton {
                                      sys{
                                        id
                                      }
                                      name
                                      linkText
                                      link
                                      styles
                                    }
                                    ... on HeadingTypes{
                                      sys{
                                        id
                                      }
                                      heading
                                      styles
                                    }
                                  }
                                }
                              }
                            }
                          }
                          contentCollection(limit:1){
                            items{
                              __typename
                              ... on SectionContainer{
                                sys{
                                  id
                                }
                                styles
                                sectionContentCollection(limit:6){
                                  items{
                                    
                                    __typename
                                    ... on HeadingTypes{
                                      sys{
                                        id
                                      }
                                      heading
                                      styles
                                    }
                                    ... on LinkButton{
                                      sys{
                                        id
                                      }
                                      linkText
                                      link
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        copyright
      }
  } 
  }`;
};
